import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {paypalDescription, type PayPalGateway} from './paypal';
import paypalBadgeURL from '../../../img/badge/paypal.svg';
import paypalImageURL from '../../../img/marks/paypal.svg';
import {PayPalPaymentButton} from './class-paypal-payment';
import {type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../../@type/features';
import {Feature} from '../../reducers/environmentReducer';
import {render} from '../../reducers/rootReducer';
import {store} from '../../store';

function initPayPalMethod(): PayPalGateway {
	let buttonInstance: PayPalPaymentButton | null = null;
	let buttonInstanceWaitingInterval: any;

	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.PAYPAL_WALLET_GATEWAY, 'title') ?? 'PayPal',
		gatewayId: 'peachpay_paypal_wallet',
		description: paypalDescription('PayPal', paypalImageURL, 'After selecting the PayPal button you will be prompted to complete your payment.'),
		assets: {
			badge: {src: paypalBadgeURL},
			title: {src: paypalImageURL},
		},
	};

	return {
		config,
		activate(paypal, orderService) {
			buttonInstance = new PayPalPaymentButton(paypal, orderService, {
				gatewayId: 'peachpay_paypal_wallet',
				fundingType: 'paypal',
				buttonStyle: Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_WALLET_GATEWAY, 'button_style') ?? undefined,
			});
			config.initialized = buttonInstance.isEligible();
			store.dispatch(render());
		},
		reset() {
			buttonInstance?.unmount();
			buttonInstance = null;
			config.initialized = false;
			store.dispatch(render());
		},
		attach(selector) {
			clearInterval(buttonInstanceWaitingInterval);
			buttonInstanceWaitingInterval = setInterval(() => {
				if (buttonInstance) {
					buttonInstance.mount(selector);
					clearInterval(buttonInstanceWaitingInterval);
				}
			}, 200);
		},
		detach() {
			buttonInstance?.unmount();
		},
	};
}

export {
	initPayPalMethod,
};
